import { Fragment, ReactElement } from 'react';
import PersonSipoNonResidentShared from 'mutation/pages/registration-marriage/non-resident/edit-person';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface PersonMarriageNonResidentNotificationsSharedProps {
  goBackUrl?: string;
  redirectUrl?: string;
  items?: BreadcrumbItem[];
}

const PersonMarriageNonResidentNotificationsShared = ({
  goBackUrl = '',
  redirectUrl = '',
  items = [],
}: PersonMarriageNonResidentNotificationsSharedProps): ReactElement => {
  return (
    <Fragment>
      <PersonSipoNonResidentShared
        redirectUrl={redirectUrl}
        goBackUrl={goBackUrl}
        breadcrumbItems={items}
      />
    </Fragment>
  );
};

PersonMarriageNonResidentNotificationsShared.displayName =
  'Research Marriage Non Resident Notifications Shared component';

export default PersonMarriageNonResidentNotificationsShared;
